import { UserInterface } from '../interfaces/user';
import {UserRole} from "./userRole";

export class User implements UserInterface {
    IDUser?: number;
    FKIDUserRole?: number;
    user_role: UserRole;
    Username: string;
    Password: string;

    constructor() {
        this.user_role = new UserRole();
        this.Username = '';
        this.Password = '';
    }
}
